export const en = {
    main_info: 'Main information',
    main_info_desc: 'Needed to arrange a business trip',
    contact_info: 'Contact information',
    contact_info_desc: 'Needed for communication on a business trip and taxi registration',
    save_changes_desc: 'The changes will only apply to new applications',
    changes_saved: 'Changes saved',
    change_user: 'Change user',
};
